import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://readybuyergroup.com.au';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'ReadyBuyer Group',
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/97714bd9b358da41691b55298de3f442/a3ed0c045a06ae061d06a7b185ca2783.png',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        areaServed: 'AU-VIC',
        availableLanguage: 'English',
        email: 'info@readybuyergroup.com.au',
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Melbourne',
        addressRegion: 'VIC',
        addressCountry: 'AU',
      },
      areaServed: {
        '@type': 'City',
        name: 'Melbourne',
      },
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: 'ReadyBuyer Group',
      publisher: { '@id': `${SITE_URL}/#organization` },
    },
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: SITE_URL,
      name: 'ReadyBuyer Group | Melbourne Property Buyers Network | Fast Offers, Zero Fees',
      description:
        "ReadyBuyer Group is Melbourne's trusted direct property buyers network. Get a written offer in 3 to 5 business days, zero agent fees, zero upfront costs.",
      isPartOf: { '@id': `${SITE_URL}/#website` },
      about: { '@id': `${SITE_URL}/#organization` },
      inLanguage: 'en-AU',
    },
    {
      '@type': 'RealEstateAgent',
      '@id': `${SITE_URL}/#realestate`,
      name: 'ReadyBuyer Group',
      url: SITE_URL,
      description:
        "Melbourne's trusted direct property buyers network offering the SureBuy Program — written offers in 3-5 business days, zero fees, zero upfront costs.",
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Melbourne',
        addressRegion: 'VIC',
        addressCountry: 'AU',
      },
      areaServed: {
        '@type': 'City',
        name: 'Melbourne',
      },
      priceRange: 'Free — Zero Fees',
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(homeSchema);
    document.head.appendChild(script);
    return () => {
      document.getElementById('schema-home')?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
